const ZERO = BigInt(0);
const ONE = BigInt(1);

export const toPermissionBigInt = (value) => {
  if (value === null || value === undefined) {
    throw new Error("Permissão inválida");
  }
  if (typeof value === "bigint") return value;
  if (typeof value === "number") {
    if (!Number.isFinite(value) || !Number.isInteger(value) || value < 0) {
      throw new Error("Permissão inválida");
    }
    return BigInt(value);
  }
  if (typeof value === "string") {
    const trimmed = value.trim().toLowerCase();
    if (!trimmed) throw new Error("Permissão inválida");
    const hex = trimmed.startsWith("0x") ? trimmed.slice(2) : trimmed;
    if (!/^[0-9a-f]+$/.test(hex)) {
      throw new Error("Permissão inválida");
    }
    return BigInt(`0x${hex}`);
  }
  throw new Error("Permissão inválida");
};

export const toPermissionHex = (value) =>
  toPermissionBigInt(value).toString(16);

export const hasPermissionBits = (mask, required) => {
  const maskBi = toPermissionBigInt(mask);
  const requiredBi = toPermissionBigInt(required);
  return (maskBi & requiredBi) === requiredBi;
};

export const orPermissions = (...values) =>
  toPermissionHex(
    values.reduce((acc, value) => acc | toPermissionBigInt(value), ZERO)
  );

export const reducePermissions = (permissionKeys) => {
  if (!permissionKeys || !permissionKeys.length) return "0";
  return orPermissions(
    ...permissionKeys.map((key) => toPermissionBigInt(key))
  );
};

export const decomposePermissions = (mask, catalogKeys) => {
  if (mask === true) return [...catalogKeys];
  return catalogKeys.filter((key) => hasPermissionBits(mask, key));
};

/** Decompose mask into hex bit keys (2^n as hex), without needing the catalog. */
export const decomposeToBitKeys = (mask) => {
  let remaining = toPermissionBigInt(mask);
  const keys = [];
  let index = ZERO;
  while (remaining > ZERO) {
    if ((remaining & ONE) === ONE) {
      keys.push((ONE << index).toString(16));
    }
    remaining >>= ONE;
    index += ONE;
  }
  return keys;
};
